import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
// 引入路由和路由配置
import VueRouter from 'vue-router'
import routerConfig from './router.config.js'
import header from './components/Header.vue'
import BaiduMap from 'vue-baidu-map'

Vue.use(ElementUI);

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key /
 ak: '0g05SAFQZ1wSwj1aC5eaWQ3UdIZHbklP'
}); 

Vue.prototype.getQueryString = function(name) { 
  let reg = `(^|&)${name}=([^&]*)(&|$)`
  let r = window.location.search.substr(1).match(reg); 
  if (r != null) return unescape(r[2]); return null; 
}

// // 使用路由
// Vue.use(VueRouter);
// // 生成路由实例
// const router = new VueRouter(routerConfig);

// 使用路由
Vue.use(VueRouter);
// 生成路由实例
const router = new VueRouter(routerConfig);

router.beforeEach((to, from, next) => {
	if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
		window.location.href = '/pages/website/index'
		return;
	}
	next()
});

// 挂载
new Vue({
  router,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js